<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.75 13.25L10 13.25C11.8856 13.25 12.8284 13.25 13.4142 12.6642C14 12.0784 14 11.1356 14 9.25L14 6.75C14 4.86438 14 3.92157 13.4142 3.33579C12.8284 2.75 11.8856 2.75 10 2.75L5 2.75"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 13.25H2C1.17157 13.25 0.5 12.5784 0.5 11.75M0.5 11.75C0.5 10.9216 1.17157 10.25 2 10.25C2.93188 10.25 3.39782 10.25 3.76537 10.0978C4.25542 9.89477 4.64477 9.50542 4.84776 9.01537C5 8.64782 5 8.18188 5 7.25V3.5C5 2.56812 5 2.10218 4.84776 1.73463C4.64477 1.24458 4.25542 0.855229 3.76537 0.652241C3.39782 0.5 2.93188 0.5 2 0.5C1.17157 0.5 0.5 1.17157 0.5 2V11.75Z"
      :stroke="color"
      stroke-linecap="round"
    />
    <path
      d="M7.25 9.76767H7.49825C7.71564 9.76767 7.82433 9.76767 7.91598 9.78923C8.00762 9.81078 8.182 9.89805 8.53075 10.0726C9.73273 10.6741 10.5344 9.62189 11.2277 8.77048C11.5759 8.3429 11.75 8.12911 11.75 7.99996C11.75 7.8708 11.5759 7.65702 11.2277 7.22944C10.5344 6.37807 9.73271 5.32591 8.53075 5.92742C8.182 6.10195 8.00763 6.18921 7.91598 6.21077C7.82433 6.23232 7.71564 6.23232 7.49826 6.23232L7.25 6.23232"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 9.5L15.5 9.5"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 12.5L15.5 12.5"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 6.5L15.5 6.5"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 3.5L15.5 3.5"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
